import React, { PureComponent } from 'react'
import uniqueId from 'lodash/uniqueId'
import isEqual from 'lodash/isEqual'
import { createFromConfig, useTheme } from '@amcharts/amcharts4/core'
// Don't remove import line, it's needed for map chart
// eslint-disable-next-line no-unused-vars
import * as am4maps from '@amcharts/amcharts4/maps'

import themeDark from '@amcharts/amcharts4/themes/dark'
import '@amcharts/amcharts4/charts'

useTheme(themeDark) // TODO: handle theme

export default class AmchartsWrapper extends PureComponent {
  constructor(props) {
    super(props)
    this.id = `amcharts4_${props.id || uniqueId('instance-')}`
  }

  buildChart() {
    const { config, onChartReady, cloneConfig = true } = this.props
    const { scrollbarX, scrollbarY } = config

    // 'createFromConfig' mutates the config, so it cannot be reused on other charts
    const chartConfig = cloneConfig
      ? JSON.parse(JSON.stringify(config))
      : config

    this.chart = createFromConfig(chartConfig, this.id)

    // Not available in JSON config
    if (scrollbarX?.parent) {
      this.chart.scrollbarX.parent = this.chart[scrollbarX.parent]
    }
    if (scrollbarY?.parent) {
      this.chart.scrollbarY.parent = this.chart[scrollbarY.parent]
    }

    if (onChartReady) {
      onChartReady(this.chart)
    }
  }

  componentDidMount() {
    this.buildChart()
  }

  componentDidUpdate(prevProps) {
    const { config, language, theme } = this.props

    const { data, series, xAxes, yAxes } = config
    const {
      data: prevData,
      series: prevSeries,
      xAxes: prevXAxes,
      yAxes: prevYAxes
    } = prevProps.config

    const dataChanged = data !== prevData

    if (dataChanged) {
      this.chart.data = data
    }

    const languageChanged = language !== prevProps.language
    const themeChanged = theme !== prevProps.theme

    const currentConfig = { series, xAxes, yAxes }
    const prevConfig = {
      series: prevSeries,
      xAxes: prevXAxes,
      yAxes: prevYAxes
    }
    const configChanged = !isEqual(currentConfig, prevConfig)

    if (languageChanged || themeChanged || configChanged) {
      this.chart.dispose()
      this.chart = null
      this.buildChart()
    }
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose()
    }
  }

  render() {
    return <div id={this.id} style={{ width: '100%', height: '100%' }} />
  }
}
